export default __webpack_public_path__ + "static/media/B59.1827ee95.png";